import { useContext } from 'react';

import { PaneContext } from '../contexts/PaneContext';

export const usePaneContext = () => useContext(PaneContext);
